<template>
  <section class="insta w-100 bg-light">
    <!-- header -->
    <div class="w-100 bg-white border-bottom py-4">
      <b-container>
        <b-row>
          <!-- content left -->
          <b-col 
            cols="6" 
          >
            <div>
              <i
                class="fas fa-heart like text-white p-2 rounded bg-danger animated fadeInDown shadow delay-1s"
              ></i>
              <h1 class="mb-0 text-purple" v-html="'Instagram'" />
              <p class="text-purple mb-0" v-html="'Confira nossas útimas postagens'" />
            </div>
          </b-col>

          <!-- content right -->
          <b-col 
            cols="6"
            class="d-flex flex-row-reverse align-items-center"
          >
            <button class="bg-transparent border-0 text-secondary d-md-none" style="outline: none;" @click="responsiveSearch">
              <i :class="responsiveSearchIcon" style="font-size: 1rem;"></i>
            </button>

            <b-form-group class="m-0 search-box" :class="responsiveSearchBox">
              <input type="text" v-model="searchString" required>
              <label for="input" class="control-label"><i class="fas fa-search d-none d-md-inline-block" style="font-size: 15px;"></i> Pesquisar</label><i class="bar"></i>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <!-- fotos -->
    <div class="w-100 py-5 bg-white">
      <b-container>
        <b-row class="py-2">
          <b-col cols="12" v-if="searchList.length > 0">
            <swiper 
              :options="swiperOption"
            >
              <swiper-slide
                v-for="img in searchList"
                :key="img.id"
                class="w-100 img-hover-zoom img-container-swiper"
                style="max-width: 20rem; height: 19rem;"
              >
                <b-img
                  width="300"
                  class="px-1"
                  :src="img.img"
                />
                <span
                  class="text-left px-5"
                  v-html="$options.filters.truncate(img.caption, 150, img.url)"
                />
              </swiper-slide>
            </swiper>
          </b-col>

          <b-col cols="12" class="text-center" v-else-if="searchList.length == 0">
            <h3><i class="fas fa-sad-tear mr-2"></i>Nenhuma foto encontrada com essa descrição...</h3>
          </b-col>
        </b-row>
      </b-container>
    </div>

  </section>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import axios from 'axios'
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      responsiveSearchBox: 'd-none d-md-inline-block',
      responsiveSearchIcon: 'fas fa-search',
      swiperOption: {
        slidesPerView: 4,
        grabCursor: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      },
      searchString: '', 
      listImages: [
        { caption: '', img: '', url: '' },
        { caption: '', img: '', url: '' },
        { caption: '', img: '', url: '' },
        { caption: '', img: '', url: '' }
      ]
    };
  }, 
  methods: {
    responsiveSearch: function () {
      this.responsiveSearchBox = this.responsiveSearchBox == 'd-none d-md-inline-block' ? '' : 'd-none d-md-inline-block'
      if (this.responsiveSearchBox == 'd-none d-md-inline-block') {
        this.responsiveSearchIcon = 'fas fa-search'
        this.searchString = ''
      } else {
        this.responsiveSearchIcon = 'fas fa-times text-danger'
      }
    },
    async getIgData () {
      let self = this
      await axios.get('https://instagram.com/vaapty', { params: { '__a': 1, 'page': 1 } })
        .then(res => {
          let { edges } = res.data.graphql.user.edge_owner_to_timeline_media
          edges.forEach((el, i) => {
            self.listImages[i].url = el.node.shortcode
            self.listImages[i].caption = el.node.edge_media_to_caption.edges[0].node.text
            self.listImages[i].img = el.node.display_url
          })
        })
    },
  },
  computed: {
    searchList: function () {
      return this.listImages.filter((list) => {
        return list.caption.toUpperCase().match(this.searchString.toUpperCase())
      })
    }
  }, 
  filters: {
    truncate: function (value, limit, url) {
      if (value.length > limit) {
        value = '<div class="px-5 font-weight-bold">' + value.substring(0, (limit - 3)) + ` <strong>(...)</strong> <a href="https://www.instagram.com/p/${url}/" target="_blank">Acessar postagem→</a></div>`
      } else {
        value = '<div class="px-5 font-weight-bold">' + value + '</div>'
      }
      return value
    }
  },
  async mounted () {
    await this.getIgData()
  }
};
</script>

<style lang="scss" scoped>
  .like {
    font-size: 12px;
    position: absolute;
    top: -10px;
    left: 173px;
  }
  .img-hover-zoom {
    height: 100%;
    overflow: hidden;
  }
  .img-hover-zoom img {
    transition: transform .5s, filter .4s ease-in-out;
    filter: opacity(100%);
  }
  .img-hover-zoom:hover img {
    transform: scale(1.02);
    filter: opacity(10%);
  }
  .img-container-swiper span {
    position: relative;
    top: -220px;
    visibility: hidden;
  }
  .img-container-swiper:hover span {
    visibility: visible;
  }
  .search-box {
    width: 300px;
  }
</style>